import { textD2CSizes } from "../../elements/text-d2c/text-d2c.constants";
import { mainNavigationClasses } from "../main-navigation/main-navigation.constants";

const { focusRing } = mainNavigationClasses;

// The footer design sets its links and addresses in 10px, which the TextD2C
// paragraph sizes do not cover. The tall line height spaces the links.
const smallTextSize = "text-[10px] leading-4";
const linkSize = "text-[10px] leading-[30px]";

/**
 * Shared classes for the footer's links, texts and buttons on its black
 * background. Links rendered with the unstyled D2C Button lose the focus ring,
 * so each adds a visible outline for keyboard users.
 */
export const footerClasses = {
  focusRing,
  link: `${focusRing} flex justify-start whitespace-normal text-left font-brand font-normal text-alabastergrey hover:text-white hover:underline ${linkSize}`,
  text: `whitespace-pre-line font-brand font-normal text-alabastergrey not-italic ${smallTextSize}`,
  cta: `${focusRing} flex justify-start whitespace-normal text-left font-brand font-normal text-alabastergrey underline underline-offset-2 hover:text-white hover:no-underline ${textD2CSizes["p-small"]}`,
  // The outline button of the design, turned light for the dark background.
  button:
    "h-[42px] border-alabastergrey/50 bg-transparent text-white hover:border-white hover:bg-white/10 focus-visible:border-white focus-visible:ring-white/50 focus-visible:ring-offset-black active:bg-transparent",
  legalLink: `${focusRing} flex whitespace-normal text-left font-brand font-normal text-white/80 hover:text-white hover:underline ${textD2CSizes["p-small"]}`,
} as const;
